export type RewardProfileMode =
  | 'CREDIT_ODDS'
  | 'POINTS_ODDS'
  | 'PHYSICAL'
  | 'LOTTERY'
  | 'MIXED'

export type PrizeAllocationRule =
  | 'FASTEST_CORRECT'
  | 'NTH_CORRECT'
  | 'FIRST_N_CORRECT'
  | 'ALL_CORRECT'
  | 'TOP_STAKE_AMONG_WINNERS'
  | 'RANDOM_AMONG_WINNERS'
  | 'LOTTERY_DRAW'

export type PredictionPrizeItem = {
  prizeId: string
  name: string
  description?: string
  quantity: number
  allocationRule: PrizeAllocationRule
  enabled?: boolean
}

export type PredictionRewardProfile = {
  profileMode?: RewardProfileMode
  monetaryEnabled?: boolean
  prizes?: PredictionPrizeItem[]
  promoHeadline?: string
  promoDescription?: string
  promoExtraNote?: string
}

export const ALLOCATION_RULE_LABELS: Record<PrizeAllocationRule, string> = {
  FASTEST_CORRECT: 'ตอบถูกเร็วที่สุด',
  NTH_CORRECT: 'ลำดับที่ N',
  FIRST_N_CORRECT: 'N คนแรกที่ถูก',
  ALL_CORRECT: 'ทุกคนที่ถูก (จำกัดจำนวน)',
  TOP_STAKE_AMONG_WINNERS: 'ยอดแทงสูงสุดในผู้ถูก',
  RANDOM_AMONG_WINNERS: 'สุ่มจากผู้ถูก',
  LOTTERY_DRAW: 'จับฉลาก (Live/Wheel)',
}
